import React from 'react';
import Text from '../text/Text';
import './styles.css';

export const ProjectSection = ({ project, isReversed = false }) => {
    const { title, description, image, titleColor } = project;

    // MUDANÇA AQUI: Em vez de criar fragmentos com <br />, 
    // criamos um array de componentes Text separados.
    // Adicionamos style={{ marginBottom: ... }} para controlar o espaço.
    const descriptionItems = description.map((item, index) => (
        <div key={index} style={{ marginBottom: '24px' }}> 
            <Text as='p'>
                {`${index + 1}. ${item}`}
            </Text>
        </div>
    ));

    const textContent = (
        <div 
            className='project-content-text' 
            id={isReversed ? 'project-content-reverse-text' : ''}
        >
            <Text as='p' fontSize={32} isBold={true} variant={titleColor}>
                {title}
            </Text>
            
            {/* MUDANÇA AQUI: Adicionamos uma pequena margem no topo para separar do título */}
            <div style={{ marginTop: '32px' }}>
                {descriptionItems}
            </div>
        </div>
    );

    const imageContent = <img src={image} alt={title} />;

    return (
        <div className='project-container'>
            <div className='project-content'>
                {/* A ordem dos elementos muda com base no `isReversed` */}
                {isReversed ? [imageContent, textContent] : [textContent, imageContent]}
            </div>
        </div>
    );
};